import React from 'react';
import './index.scss'

export default function Arrow ({direction, ...props}) {
  return <div className={`arrow ${direction} normal-arrow`} {...props}/>
}

Arrow.Circle = function Arrow ({direction, ...props}) {
  return <div className={`arrow ${direction} circle-arrow`} {...props}/>
};